import axios from "axios";
import globals from "../config/appconfig";
import Utils from "../utils/Utils";
import OggettiUtili from "../utils/OggettiUtili.json";

export default class SegnalazioniHIVServices {
    static urlGetSegnalazioni =
        globals["app-url-backend-segnalazioni-hiv"] +
        "/segnalazioniHIV/ricercaSegnalazioniHIV";
    static urlGetDuplicati =
        globals["app-url-backend-segnalazioni-hiv"] +
        "/segnalazioniHIV/ricercaDuplicatiSegnalazioniHIV";
    static urlGetSegnalazione =
        globals["app-url-backend-segnalazioni-hiv"] +
        "/segnalazioniHIV/getSegnalazioneHIV/{progressivoRegistro}";
    static urlGetAnagrafica =
        globals["app-url-backend-segnalazioni-hiv"] +
        "/anagraficaHIV/ricercaAnagraficaHIV/{idPaziente}";
    static urlPostSegnalazione =
        globals["app-url-backend-segnalazioni-hiv"] +
        "/segnalazioniHIV/creazioneSegnalazioneHIV";
    static urlPostAnagrafica =
        globals["app-url-backend-segnalazioni-hiv"] +
        "/anagraficaHIV/creazioneAnagraficaHIV";
    static urlPutSegnalazione =
        globals["app-url-backend-segnalazioni-hiv"] +
        "/segnalazioniHIV/modificaSegnalazioneHIV/{progressivoRegistro}";
    static urlPutAnagrafica =
        globals["app-url-backend-segnalazioni-hiv"] +
        "/anagraficaHIV/modificaAnagraficaHIV/{idPaziente}";
    static urlArchiviaSegnalazione =
        globals["app-url-backend-segnalazioni-hiv"] +
        "/segnalazioniHIV/archiviaSegnalazioneHIV/{progressivoRegistro}";

    static createQuerystring = (params) => {
        let querystring = "?";

        Object.keys(params).forEach(function (key) {
            querystring += key + "=" + params[key] + "&";
        });
        return querystring.substring(0, querystring.length - 1);
    };

    static getSegnalazioniHIV(params) {
        return axios.get(
            this.urlGetSegnalazioni + this.createQuerystring(params)
        );
    }

    static getDuplicatiSegnalazioniHiv(params) {
        return axios.get(this.urlGetDuplicati + this.createQuerystring(params));
    }

    static mapGetSegnalazioniHIV(data) {
        let res = [];
        let aulss = OggettiUtili.ulssMapHIV;
        data.data.content.forEach(function (el) {
            el.appoStruttura = el.codiceStruttura;
            el.codiceStruttura = el.codiceStruttura
                ? aulss[el.codiceStruttura].descrizione
                : "";
            res.push(el);
        });
        return res;
    }

    static mapDataAnagraficaForBackend(inputData) {
        return {
            codiceIndividuale: inputData.valoreCodice,
            annoNascita: inputData.annoNascita,
            eta: inputData.eta,
            sesso: inputData.sesso.substring(0, 1),
            ulssResidenza: inputData.ulssResidenza.codice
                ? inputData.ulssResidenza.codice
                : inputData.ulssResidenza.codiceAziendaEsteso,
            luogoNascita: inputData.luogoNascita.codice,
            luogoResidenza:
                inputData.statoResidenza ===
                OggettiUtili.STATO_RESIDENZA.SENZA_FISSA_DIMORA
                    ? "SFD"
                    : inputData.luogoResidenza.codice,
            cittadinanza: inputData.cittadinanza.codice,
        };
    }

    static mapDataAnagraficaForFrontend(inputData) {
        Object.keys(inputData).forEach((el) => {
            inputData[el] = inputData[el] === null ? "" : inputData[el];
        });

        const AULSS = Utils.distinctAulss(
            JSON.parse(localStorage.getItem("aulss"))
        );

        const NAZIONI = JSON.parse(sessionStorage.getItem("nazioni"));

        const PROVINCE = JSON.parse(sessionStorage.getItem("province"));

        const statoNascita =
            inputData.luogoNascita === ""
                ? ""
                : inputData.luogoNascita.startsWith("Z")
                ? OggettiUtili.STATO_NASCITA.NATO_ESTERO
                : OggettiUtili.STATO_NASCITA.NATO_IN_ITALIA;

        const statoResidenza =
            inputData.luogoResidenza === "" ||
            inputData.luogoResidenza === "SFD"
                ? OggettiUtili.STATO_RESIDENZA.SENZA_FISSA_DIMORA
                : inputData.luogoResidenza.startsWith("Z")
                ? OggettiUtili.STATO_RESIDENZA.RESIDENTE_ESTERO
                : OggettiUtili.STATO_RESIDENZA.RESIDENTE_IN_ITALIA;

        const cittadinanza =
            inputData.cittadinanza === ""
                ? ""
                : NAZIONI.find((el) => el.codice === inputData.cittadinanza);

        const luogoNascita =
            inputData.luogoNascita === ""
                ? ""
                : inputData.luogoNascita.startsWith("Z")
                ? NAZIONI.find((el) => el.codice === inputData.luogoNascita)
                : Utils.getComuneByDescrizione(
                      inputData.luogoNascita,
                      inputData.annoNascita.toString()
                  );

        const luogoResidenza =
            inputData.luogoResidenza === ""
                ? ""
                : inputData.luogoResidenza === "SFD"
                ? OggettiUtili.STATO_RESIDENZA.SENZA_FISSA_DIMORA
                : inputData.luogoResidenza.startsWith("Z")
                ? NAZIONI.find((el) => el.codice === inputData.luogoResidenza)
                : Utils.getComuneByDescrizione(
                      inputData.luogoResidenza,
                      Utils.getTodayDate()
                  );

        const ulssResidenza =
            inputData.ulssResidenza === "" ? "" : AULSS.find((el) => el.codiceAziendaEsteso === inputData.ulssResidenza);

        const sesso =
            inputData.sesso === "M"
                ? "Maschio"
                : inputData.sesso === "F"
                ? "Femmina"
                : "";

        const provinciaResidenza =
            inputData.luogoResidenza !==
                OggettiUtili.STATO_RESIDENZA.SENZA_FISSA_DIMORA &&
            inputData.luogoResidenza !== "" &&
            !inputData.luogoResidenza.startsWith("Z")
                ? PROVINCE.find(
                      (el) => el.codice === luogoResidenza.codiceProvincia
                  )
                : "";

        return {
            datiAnagrafica: {
                id: inputData.id,
                eta: inputData.eta,
                sesso: sesso,
                annoNascita: inputData.annoNascita,
                annoNascitaErrore: "",
                statoNascita: statoNascita,
                luogoNascita: luogoNascita,
                cittadinanza: cittadinanza,
                statoResidenza: statoResidenza,
                luogoResidenza: luogoResidenza,
                ulssResidenza: ulssResidenza,
                provinciaResidenza: provinciaResidenza,
            },
            codicePaziente: {
                valoreCodice: inputData.codiceIndividuale,
                errorMessage: "",
            },
        };
    }

    static mapDataSegnalazioneForBackend(inputData) {
        // converti le date presenti
        const dateFields = [
            "dataUltimoTestNegativo",
            "dataPrimaPositivita",
            "dataPresoInCaricoDalReparto",
            "dataAnamnesi",
            "dataEsameHIV",
            "dataSegnalazione",
            "dataCompilazione",
        ];

        // trasforma i capi data
        for (let key of Object.keys(inputData)) {
            for (let subKey of Object.keys(inputData[key])) {
                // check validità campi data
                for (let dateField of dateFields) {
                    if (dateField === subKey && inputData[key][subKey] !== "")
                        inputData[key][subKey] = Utils.transformDateForBackend(
                            inputData[key][subKey]
                        );
                }
            }
        }

        return {
            annoFineDroghe: inputData.rischio.annoFineIniezioni,
            annoInizioDroghe: inputData.rischio.annoInizioIniezioni,
            codiceIndividualePaziente: inputData.codicePaziente.valoreCodice,
            codiceStruttura: inputData.datiSegnalazione.ulssSegnalazione.codice
                ? inputData.datiSegnalazione.ulssSegnalazione.codice
                : inputData.datiSegnalazione.ulssSegnalazione.codiceAziendaEsteso,
            struttura: inputData.datiSegnalazione.struttura,
            comportamentoRischio: inputData.rischio.comportamentoRischio,
            comportamentoRischioAltro:
                inputData.rischio.altroComportamentoRischio,
            comportamentoRischioRapportiSessuali:
                inputData.rischio.naturaRapportiSessuali,
            dataAnamnesi: inputData.anamnesiPaziente.dataAnamnesi,
            dataEsame: inputData.esitoHIV.dataEsameHIV,
            esitoEsame: inputData.esitoHIV.esitoHIV,
            dataReparto: inputData.anamnesiPaziente.dataPresoInCaricoDalReparto,
            dataSegnalazione: inputData.datiSegnalazione.dataSegnalazione,
            dataCompilazione: inputData.datiSegnalazione.dataCompilazione,
            idPaziente: inputData.id
                ? inputData.id
                : inputData.datiAnagrafica.id,
            linfociti: inputData.anamnesiPaziente.numeroAssolutoLinfocitiCD4,
            luogoInfezione:
                inputData.anamnesiPaziente.presuntoLuogoAvvenutaInfezione,
            motivoEsame: inputData.anamnesiPaziente.motivazioneEsame,
            progressivoRegistro: inputData.datiSegnalazione.progressivoRegistro,
            ultimoTestNegativo:
                inputData.anamnesiPaziente.dataUltimoTestNegativo,
            dataPrimaPositivita: inputData.anamnesiPaziente.dataPrimaPositivita,
            archiviato: false,
        };
    }

    static mapDataSegnalazioneForFrontend(inputData) {
        // converti le date presenti
        const dateFields = [
            "dataCompilazione",
            "dataPrimaPositivita",
            "dataReparto",
            "dataSegnalazione",
            "ultimoTestNegativo",
            "dataAnamnesi",
            "dataEsame",
        ];

        // converti campi null in stringhe vuote e trasforma i capi data
        Object.keys(inputData).forEach((el) => {
            inputData[el] = inputData[el] === null ? "" : inputData[el];
            for (let dateField of dateFields) {
                if (el === dateField && inputData[el] !== "")
                    inputData[el] = Utils.transformDateForFrontend(
                        inputData[el]
                    );
            }
        });

        const arrayUlss = Utils.mapToArray(OggettiUtili.ulssMapHIV);

        const ulssSegnalazione =
            inputData.codiceStruttura !== ""
                ? arrayUlss.find(
                      (el) => el.codice === inputData.codiceStruttura
                  )
                : "";

        const comportamentoRischio = inputData.comportamentoRischio
            ? OggettiUtili.COMPORTAMENTI_A_RISCHIO[
                  Object.keys(OggettiUtili.COMPORTAMENTI_A_RISCHIO).find(
                      (key) =>
                          OggettiUtili.COMPORTAMENTI_A_RISCHIO[key].id ===
                          inputData.comportamentoRischio
                  )
              ]["id"]
            : "";
        const comportamentoRischioRapportiSessuali =(
            inputData.comportamentoRischio === 1003 ||
            inputData.comportamentoRischio === 1004 ||
            inputData.comportamentoRischio === 1005 ||
            inputData.comportamentoRischio === 1006 ||
            inputData.comportamentoRischio === 1007) && inputData.comportamentoRischioRapportiSessuali
                ? OggettiUtili.RAPPORTI_SESSUALI[
                      Object.keys(OggettiUtili.RAPPORTI_SESSUALI).find(
                          (key) =>
                              OggettiUtili.RAPPORTI_SESSUALI[key].id ===
                              inputData.comportamentoRischioRapportiSessuali
                      )
                  ]["id"]
                : "";
        return {
            datiSegnalazione: {
                progressivoRegistro:
                    inputData.codiceStruttura +
                    Utils.progressivoRegistroZero(
                        inputData.progressivoRegistro
                    ),
                dataCompilazione: inputData.dataCompilazione,
                dataSegnalazione: inputData.dataSegnalazione,
                ulssSegnalazione: ulssSegnalazione,
                struttura: inputData.struttura,
            },
            codicePaziente: {
                valoreCodice: inputData.codiceIndividualePaziente,
                errorMessage: "",
            },
            rischio: {
                comportamentoRischio: comportamentoRischio,
                comportamentoRischioDroghe: "",
                altroComportamentoRischio: inputData.comportamentoRischioAltro,
                annoInizioIniezioni:
                    inputData.annoInizioDroghe === 0
                        ? ""
                        : inputData.annoInizioDroghe,
                annoInizioIniezioniErrore: "",
                annoFineIniezioni:
                    inputData.annoFineDroghe === 0
                        ? ""
                        : inputData.annoFineDroghe,
                annoFineIniezioniErrore: "",
                naturaRapportiSessuali: comportamentoRischioRapportiSessuali,
            },
            anamnesiPaziente: {
                dataUltimoTestNegativo: inputData.ultimoTestNegativo,
                dataPrimaPositivita: inputData.dataPrimaPositivita,
                presuntoLuogoAvvenutaInfezione: inputData.luogoInfezione,
                dataPresoInCaricoDalReparto: inputData.dataReparto,
                dataAnamnesi: inputData.dataAnamnesi,
                motivazioneEsame: inputData.motivoEsame,
                numeroAssolutoLinfocitiCD4: inputData.linfociti,
            },
            esitoHIV: {
                dataEsameHIV: inputData.dataEsame,
                esitoHIV: inputData.esitoEsame,
            },
        };
    }

    static mapData(type, destination, input) {
        let output;
        if (type === "anagrafica" && destination === "backend")
            output = this.mapDataAnagraficaForBackend(input);
        if (type === "anagrafica" && destination === "frontend")
            output = this.mapDataAnagraficaForFrontend(input);
        if (type === "segnalazione" && destination === "backend")
            output = this.mapDataSegnalazioneForBackend(input);
        if (type === "segnalazione" && destination === "frontend")
            output = this.mapDataSegnalazioneForFrontend(input);
        return output;
    }

    static mapProgressivoRegistro = (progressivoRegistro) =>
        +progressivoRegistro.toString().substring(6);

    static getSegnalazioneHIV(progressivoRegistro) {
        progressivoRegistro = this.mapProgressivoRegistro(progressivoRegistro);
        return axios.get(
            this.urlGetSegnalazione.replace(
                "{progressivoRegistro}",
                progressivoRegistro
            )
        );
    }

    static getAnagraficaHIV(idPaziente) {
        return axios.get(
            this.urlGetAnagrafica.replace("{idPaziente}", idPaziente)
        );
    }

    static postSegnalazioneHIV(jsonInsertSegnalazione) {
        return axios.post(this.urlPostSegnalazione, jsonInsertSegnalazione);
    }

    static postAnagraficaHIV(jsonInsertAnagrafica) {
        return axios.post(this.urlPostAnagrafica, jsonInsertAnagrafica);
    }

    static putSegnalazioneHIV(jsonInsertSegnalazione, progressivoRegistro) {
        progressivoRegistro = this.mapProgressivoRegistro(progressivoRegistro);
        jsonInsertSegnalazione.progressivoRegistro = progressivoRegistro;
        return axios.put(
            this.urlPutSegnalazione.replace(
                "{progressivoRegistro}",
                progressivoRegistro
            ),
            jsonInsertSegnalazione
        );
    }

    static putAnagraficaHIV(jsonInsertAnagrafica, idPaziente) {
        return axios.put(
            this.urlPutAnagrafica.replace("{idPaziente}", idPaziente),
            jsonInsertAnagrafica
        );
    }

    static archiviaSegnalazioneHIV(progressivoRegistro) {
        progressivoRegistro = this.mapProgressivoRegistro(progressivoRegistro);
        let jsonInsertSegnalazione = {
            progressivoRegistro: progressivoRegistro,
            archiviato: true,
        }
        return axios.put(this.urlArchiviaSegnalazione.replace("{progressivoRegistro}", progressivoRegistro), jsonInsertSegnalazione);
    }
}
